import * as React from 'react';
import { Accordion } from 'semantic-ui-react';

import AccordionTitle from './AccordionTitle';
import { BaseAlphasAccordionProps as AlphasAccordionProps } from './AccordionTitle';

interface AlphasAccordionState {
  showContent: boolean;
  requestData: boolean;
}

interface AlphasAccordionWithChildrenProps extends AlphasAccordionProps {
  children?: React.ReactNode;
}

class AlphasAccordion extends React.Component<AlphasAccordionWithChildrenProps, AlphasAccordionState> {
  state: AlphasAccordionState = { showContent: false, requestData: true };

  handlerShowAccordion = () => {
    if (this.state.requestData) {
      this.props.handleRefreshData();
      this.setState({ requestData: false });
    }
    this.setState((state: any) => ({ showContent: !state.showContent }));
  };

  render() {
    return (
      <Accordion>
        <Accordion.Title className="sumary__metrics" active={this.state.showContent}>
          <AccordionTitle
            performanceAlphaSummaryTitle={this.props.performanceAlphaSummaryTitle}
            performanceAlphaSummaryTitleValues={this.props.performanceAlphaSummaryTitleValues}
            performanceAlphaSummary={this.props.performanceAlphaSummary}
            performanceAlphaDatafieldsScoreTitle={this.props.performanceAlphaDatafieldsScoreTitle}
            performanceAlphaDatafieldsScore={this.props.performanceAlphaDatafieldsScore}
            performanceAlphaRobustnessScoreTitle={this.props.performanceAlphaRobustnessScoreTitle}
            performanceAlphaRobustnessScore={this.props.performanceAlphaRobustnessScore}
            performanceAlphaWeeklyScoreTitle={this.props.performanceAlphaWeeklyScoreTitle}
            performanceAlphaWeeklyScore={this.props.performanceAlphaWeeklyScore}
            competition={this.props.competition}
            canRefresh={this.props.canRefresh}
            date={this.props.date}
            fetchingData={this.props.fetchingData}
            handleRefreshData={this.props.handleRefreshData}
            handlerShowAccordion={this.handlerShowAccordion}
            showContent={this.state.showContent}
          />
        </Accordion.Title>
        <Accordion.Content active={this.state.showContent}>{this.props.children}</Accordion.Content>
      </Accordion>
    );
  }
}

export default AlphasAccordion;
